<template>
  <a-layout-header class="header">
    <a-row>
      <a-col :span="12">
          <div  v-show="get_active_tenant.name">
            <span style="padding-left:2em;">
              <a-badge>
                <a-icon slot="count" type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
                <a-avatar shape="square" size="large" icon="cloud" class="primary-avatar" />
              </a-badge>
              <span style="margin-left:1em" class="lead">{{get_active_tenant.name}}</span>
            </span>
          </div>
      </a-col>
      <a-col :span="12">
        <div class="ant-menu-horizontal">
          <a-dropdown
            :trigger="['click']"
            placement="bottomRight"
            :overlayStyle="{left: '1145px', top: '50px'}"
            v-if="userinfo"
          >
            <span style="padding-right:10px;">
              <a-badge dot>
                <a-avatar shape="square" size="large" icon="switcher" class="primary-avatar" />
              </a-badge>
            </span>
            <a-menu slot="overlay" style="width:auto; padding-top:5px;">
              <a-menu-item key="t">
                <strong>Hello, {{userinfo.given_name}}</strong>
                <div v-if="has_orgs">
                  <span>Switch between your tenants</span>
                </div>
              </a-menu-item>
              <a-menu-divider v-if="has_orgs" />
              <a-menu-item v-for="k in get_orgs" :key="k._uuid">
                <a v-if="k._uuid == get_active_tenant._uuid">
                  <a-icon type="cloud" theme="filled" style="padding-right:10px;color:green;" />
                  {{k.name}}
                  <a-icon
                    type="check-circle"
                    theme="filled"
                    style="padding-left:10px;color:green;"
                  />
                </a>
                <a v-else @click="changeTenant(k._uuid)">
                  <a-icon type="cloud" theme="filled" style="padding-right:10px;color:gray;" />
                  {{k.name}}
                </a>
              </a-menu-item>
              <a-menu-divider />
              <a-menu-item key="a">
                <a @click.prevent="showDrawer">
                  <a-icon type="plus-circle" style="padding-right:10px;"></a-icon>Create new tenant
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-dropdown
            :trigger="['click']"
            placement="bottomRight"
            :overlayStyle="{left: '1145px', top: '50px'}"
          >
            <span style="padding-right:50px;">
              <a-badge dot>
                <a-avatar shape="square" size="large" icon="user" class="primary-avatar" />
              </a-badge>
            </span>
            <a-menu slot="overlay" style="width:150px; padding-top:5px;">
              <a-menu-item key="1" @click="handleClick">
                <a>
                  <a-icon type="setting" theme="filled" style="padding-right:10px;"></a-icon>Settings
                </a>
              </a-menu-item>
              <a-menu-item key="2" @click="handleClick">
                <a>
                  <a-icon type="notification" theme="filled" style="padding-right:10px;"></a-icon>Notifications
                </a>
              </a-menu-item>
              <a-menu-divider />
              <a-menu-item key="3">
                <a @click.prevent="doLogout">
                  <a-icon type="logout" style="padding-right:10px;"></a-icon>Logout
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
        <a-create-tenant />
      </a-col>
    </a-row>
  </a-layout-header>
</template>

<script>
import { mapGetters } from 'vuex';
import ACreateTenant from "@/components/Drawer/ACreateTenant";
import axiomsApiDomain from "@/helpers/AxiomsApiDomain";

export default {
  data() {
    return {
      test: ""
    };
  },
  components: {
    ACreateTenant
  },
  methods: {
    doLogout: function() {
      this.$auth.logout_with_redirect();
    },
    showDrawer() {
      this.$store.dispatch("ui/showDrawer", {
        drawer_name: "create_tenant"
      });
    },
    changeTenant(uuid) {
      console.log(uuid);
      this.$auth.switch_organization(uuid);
    },
    handleClick({ key }) {
      switch (key) {
        case "1":
          this.$router.push("/user-settings");
          break;
      }
    }
  },
  computed: {
  
    ...mapGetters("axioms", ['active_tenant']),

    userinfo() {
      return this.$store.state.axioms.userinfo;
    },
    get_active_tenant(){
      return this.active_tenant(this.$auth.session.org);
    }, 
    tenant() {
      return this.$store.state.core.tenants_item;
    },
    orgs_uri() {
      return `https://${axiomsApiDomain()}/claims/orgs`
    },
    has_orgs() {
      var userinfo = this.$store.state.axioms.userinfo;
      console.log(userinfo[this.orgs_uri]);
      return userinfo[this.orgs_uri].length ? true : false
    },
    get_orgs() {
      var userinfo = this.$store.state.axioms.userinfo;
      return userinfo[this.orgs_uri]
    }
  },
  beforeCreate: async function() {
    try {
      await this.$store.dispatch("axioms/getUserInfo");
    } catch (error) {
      console.error(error);
    }
  }
};
</script>

<style lang="css">
.ant-layout-header {
  padding: 0 !important;
}
.ant-menu-horizontal {
  float: right;
  border-bottom: none !important;
  line-height: 60px !important;
}
@media screen and (min-width: 576px) {
}

/* Medium devices (tablets, 768px and up) */
@media screen and (min-width: 768px) {
}

/*  Large devices (desktops, 992px and up) */
@media screen and (min-width: 992px) {
}

/* Extra large devices (large desktops, 1200px and up) */
@media screen and (min-width: 1200px) {
}
</style>